module.exports = __webpack_public_path__ + "static/phpworld18-1917b656dc7db33241689dedec4a3d67.jpeg";